import styled from 'styled-components';
import { font, breakpoint } from 'styles/globals';
import { getColor, Theme } from 'styles/theme';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${(props) => props.color};
  width: 64px;
  height: 64px;
  padding: 7px;

  @media (${breakpoint.xlMin}) {
    &:not(.rankings-mentioning) {
      width: 96px;
      height: 96px;

      .label {
        margin-top: 8px;
      }
      .value {
        font-size: 32px;
        margin-top: 8px;
      }
    }
  }
`;

export const Label = styled.span<{ theme: Theme }>`
  font-family: ${font.graphikCond};
  font-size: 12px;
  font-weight: 500;
  color: ${getColor('neutralWhite')};
  letter-spacing: 1.008px;
  line-height: 18px;
  text-align: center;
  text-transform: uppercase;

  @media (${breakpoint.xlMin}) {
    margin-top: 0;
  }
`;

export const Value = styled.span<{ theme: Theme }>`
  font-family: ${font.graphikCond};
  font-size: 24px;
  font-weight: 600;
  color: ${getColor('neutralWhite')};
  letter-spacing: 0.176px;
  line-height: 28.8px;
  text-align: center;
  text-transform: uppercase;
  margin-top: 3px;
`;
